import { render, staticRenderFns } from "./Saida.vue?vue&type=template&id=8027ef46"
import script from "./Saida.vue?vue&type=script&lang=js"
export * from "./Saida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports